import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';

const LOGO_URL = '/images/logo.png';

export default function Footer() {

  return (
    <footer className="bg-brand-primary text-white py-12" data-testid="footer">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <img src={LOGO_URL} alt="ZAN Aqua" className="h-16 mb-4 brightness-0 invert" />
              <p className="text-slate-300">Premium RO-filtered water for your health and wellness.</p>
            </div>
            <div>
              <h4 className="text-lg font-medium mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/products" className="text-slate-300 hover:text-white transition-colors duration-200">Products</Link></li>
                <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors duration-200">About Us</Link></li>
                <li><Link to="/contact" className="text-slate-300 hover:text-white transition-colors duration-200">Contact</Link></li>
                <li><Link to="/payment-info" className="text-slate-300 hover:text-white transition-colors duration-200">Payment Info</Link></li>
                <li><Link to="/franchise" className="text-slate-300 hover:text-white transition-colors duration-200">Franchise Opportunities</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-medium mb-4">Contact Info</h4>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <Phone className="h-5 w-5 text-brand-accent mt-0.5" />
                  <span className="text-slate-300">+92-301-719-6699</span>
                </div>
                <div className="flex items-start space-x-3">
                  <Mail className="h-5 w-5 text-brand-accent mt-0.5" />
                  <span className="text-slate-300">info@zanaqua.com</span>
                </div>
                <div className="flex items-start space-x-3">
                  <MapPin className="h-5 w-5 text-brand-accent mt-0.5" />
                  <span className="text-slate-300">A-6 Commercial Market, Phase II, Agrics Town, Raiwind Road, Lahore</span>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-slate-700 pt-8 text-center text-slate-400">
            <p>&copy; {new Date().getFullYear()} ZAN Aqua. All rights reserved.</p>
          </div>
        </div>
      </footer>
  );
}
